import { SectionName } from '../../../lib/interfaces/tabbedCarouselsContent';
import { LazyLoadSections, ShortTitlesSections } from './types';

export const isValidSectionNames = (sectionNames: SectionName[]): sectionNames is [SectionName, ...SectionName[]] =>
    sectionNames.length > 0;

export const enrichTabbedCarouselData = (sections: Record<string, any>) => {
    const values = Object.values(sections).flat();
    const firstTab = values[0];

    return {
        first_tab_asset: firstTab?.type,
        first_tab_logic: firstTab?.name,
        shown_tabs: values.map((section) => section.name),
    };
};

export const eagerSectionMap: Record<string, LazyLoadSections> = {
    warm_start_eager: 'warm_start',
    pickup_eager: 'pickup',
    search_history_eager: 'search_history',
    store_builder_eager: 'store_builder',
};

export const ShortTitlesSectionMap: Record<string, ShortTitlesSections> = {
    warm_start_eager: 'warm_start',
    cold_start: 'cold_start',
};
